<div class="td-card td-team-overview-card">
  <div class="td-card-header">
    <div class="td-card-heading">
      <h2 class="td-card-title">{{ 'td_team_overview_title' | translate }}</h2>
      <span class="td-card-subtitle" *ngIf="data?.latestCheckIn">
        {{ 'td_team_overview_latest_checkin' | translate : {date: data?.latestCheckIn} }}
      </span>
    </div>
    <div class="td-table-filters">
      <span class="td-table-filters-label">{{ 'td_team_overview_sort_by' | translate }}</span>
      <p-dropdown [options]="categoryOptions"
                  [(ngModel)]="categoryValue"
                  optionLabel="label" optionValue="value"
                  dropdownIcon="bi bi-caret-down-fill"
                  styleClass="td-filter-dropdown"
                  panelStyleClass="td-filter-dropdown-panel"
                  (onChange)="onFilterChange()">
      </p-dropdown>
      <p-dropdown [options]="sortOptions"
                  [(ngModel)]="sortValue"
                  optionLabel="label" optionValue="value"
                  dropdownIcon="bi bi-caret-down-fill"
                  styleClass="td-filter-dropdown"
                  panelStyleClass="td-filter-dropdown-panel"
                  (onChange)="onFilterChange()">
      </p-dropdown>
    </div>
  </div>

  <div class="td-table-body" [ngClass]="{'is-loading': loading}">
    <div class="td-table-tray">
      <p-table [value]="visibleRows" [rowTrackBy]="trackByUuid" responsiveLayout="scroll">
        <ng-template pTemplate="colgroup">
          <colgroup>
            <col class="td-col-team">
            <col *ngFor="let column of data?.columns; let first = first; let last = last"
                 [ngClass]="{'td-col-narrow': first || last}">
            <col class="td-col-overall">
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>
              <div class="td-table-cell td-header-cell td-team-cell">{{ 'team' | translate | uppercase }}</div>
            </th>
            <th *ngFor="let column of data?.columns">
              <div class="td-table-cell td-header-cell">
                <span class="td-header-icon">
                  <img [src]="column.icon" [alt]="column.title">
                </span>
                <span class="td-header-label">{{ column.title | uppercase }}</span>
              </div>
            </th>
            <th>
              <div class="td-table-cell td-header-cell">
                {{ 'td_team_overview_overall_score_column' | translate | uppercase }}
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <div class="td-table-cell td-team-cell">
                <span class="team-name" [routerLink]="['/team-dynamics-reporting/team', row.teamUuid]">{{ row.teamName }}</span>
              </div>
            </td>
            <td *ngFor="let cell of row.cells">
              <div class="td-table-cell" [ngStyle]="{'background-color': cell.fadeColor}"
                   [pTooltip]="cell.title" tooltipPosition="bottom"
                   tooltipStyleClass="member-email-tooltip td-tooltip">
                <ng-container *ngIf="cell.score !== null">
                  {{ cell.score }}%
                  <img *ngIf="cell.trend" [src]="'../../../assets/svg/indicator-arrow-' + cell.trend + '.svg'" alt="">
                </ng-container>
                <ng-container *ngIf="cell.score === null">-</ng-container>
              </div>
            </td>
            <td>
              <div class="td-table-cell td-overall-cell" [ngStyle]="{'color': row.overallColor}">
                {{ row.overallScore !== null ? (row.overallScore + '%') : '-' }}
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="(data?.columns?.length || 0) + 2">
              <div class="td-table-cell td-table-empty">{{ 'td_no_data' | translate }}</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <span class="td-table-toggle" *ngIf="hasHiddenRows" (click)="toggleShowAll()">
      {{ showAll ?
        ('td_team_overview_show_fewer' | translate) :
        ('td_team_overview_view_all' | translate : {count: data?.rows?.length}) }}
      <i class="bi bi-arrow-right"></i>
    </span>

    <div class="td-table-loading" *ngIf="loading">
      <div class="spinner-border text-primary td-table-spinner" role="status"></div>
    </div>
  </div>
</div>
